<template>
  <div class="user">
    <!--搜索区域-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="必备证书名称">
          <el-input placeholder="请输入必备证书名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--操作栏-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加必备证书</el-button>
    </div>

    <!--表格区域-->
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="必备证书名称"></el-table-column>
            <el-table-column prop="price" label="价格">
              <template slot-scope="scope">
                {{ scope.row.price }}元
              </template>
            </el-table-column>
            <el-table-column prop="ml.name" label="目录"></el-table-column>

            <!-- 合伙人分佣金额列 -->
            <el-table-column prop="partner_commission" label="合伙人分佣金额" width="180">
              <template slot-scope="scope">
                <div class="commission-cell">
                  <el-input 
                    v-model="scope.row.partner_commission" 
                    size="mini" 
                    placeholder="请输入分佣金额"
                    :disabled="scope.row.saving"
                    @blur="handleCommissionChange(scope.row)"
                    @keyup.enter.native="handleCommissionChange(scope.row)"
                  >
                    <template slot="append">元</template>
                  </el-input>
                  <i class="el-icon-loading" v-if="scope.row.saving"></i>
                  <i class="el-icon-success success-icon" v-if="scope.row.saveSuccess"></i>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!--添加弹窗-->
    <Add :open_add="open_add" :supply_id="supply_id" v-if="open_add" @close="closeAdd"></Add>
    
    <!--编辑弹窗-->
    <Edit :open_add="open_edit" :certificate_certificate_id="certificate_certificate_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!--设置标题弹窗-->
    <el-dialog 
      style="text-align: center" 
      title="设置标题" 
      :visible.sync="dialogVisible" 
      @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
import Certificate_certificateApi from '@/api/certificate_certificate.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      supply_id: this.$route.query.supply_id,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      certificate_certificate_id: "",
      dialogVisible: false,
      
      // 保存防抖定时器
      saveTimer: null,
      // 当前正在保存的行ID
      savingRowId: null
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    
    setting(e) {
      this.dialogVisible = true;
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.supply_id = self.supply_id;
      self.loading = true;
      
      Certificate_certificateApi.list(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            // 处理数据，确保每个记录都有 partner_commission 字段
            self.tableData = data.data.list.data.map(item => {
              return {
                ...item,
                partner_commission: item.commissionValue || 0,
                original_commission: item.commissionValue || 0, // 保存原始值用于回滚
                saving: false, // 保存状态
                saveSuccess: false // 保存成功状态
              };
            });
            self.totalDataNumber = data.data.list.total;
          } else {
            self.$message.error(data.msg || '获取数据失败');
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('网络错误，请稍后重试');
          console.error('获取列表失败:', error);
        });
    },

    /* 处理分佣金额变化 */
    handleCommissionChange(row) {
      // 如果值没有变化，则不保存
      if (row.partner_commission === row.original_commission) {
        return;
      }

      // 验证输入的值
      if (row.partner_commission === '' || row.partner_commission === null || row.partner_commission === undefined) {
        this.$message.warning('分佣金额不能为空');
        row.partner_commission = row.original_commission;
        return;
      }

      // 验证是否为有效数字
      const commissionValue = parseFloat(row.partner_commission);
      if (isNaN(commissionValue)) {
        this.$message.error('请输入有效的数字');
        row.partner_commission = row.original_commission;
        return;
      }

      if (commissionValue < 0) {
        this.$message.error('分佣金额不能为负数');
        row.partner_commission = row.original_commission;
        return;
      }

      // 清除之前的定时器
      if (this.saveTimer) {
        clearTimeout(this.saveTimer);
      }

      // 设置保存状态
      this.$set(row, 'saving', true);
      this.$set(row, 'saveSuccess', false);
      this.savingRowId = row.certificate_certificate_id;

      // 设置新的定时器，延迟300ms保存，避免频繁请求
      this.saveTimer = setTimeout(() => {
        this.saveCommission(row, commissionValue);
      }, 300);
    },

    /* 保存分佣金额 */
    saveCommission(row, commissionValue) {
      Certificate_certificateApi.edit({
        certificate_certificate_id: row.certificate_certificate_id,
        name: row.name,
        price:row.price,
        ml_directory_id:row.ml_directory_id,
        bk_detail:row.bk_detail,
        image:row.image,
        intro:row.intro,
        service_qrcode:row.service_qrcode,
        bannar:row.bannar,
        sort:row.sort,
        commissionValue:commissionValue
      }, true)
        .then(data => {
          this.$set(row, 'saving', false);
          this.savingRowId = null;
          
          if (data.code == 1) {
            this.$set(row, 'saveSuccess', true);
            // 保存成功后更新原始值
            row.original_commission = commissionValue;
            
            // 2秒后隐藏成功图标
            setTimeout(() => {
              this.$set(row, 'saveSuccess', false);
            }, 2000);
          } else {
            this.$message.error(data.msg || '保存失败');
            // 保存失败时恢复原值
            row.partner_commission = row.original_commission;
          }
        })
        .catch(error => {
          this.$set(row, 'saving', false);
          this.savingRowId = null;
          this.$message.error('保存失败，请检查网络连接');
          // 保存失败时恢复原值
          row.partner_commission = row.original_commission;
          console.error('保存分佣金额失败:', error);
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.certificate_certificate_id = row.certificate_certificate_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Certificate_certificateApi.del(
            {
              certificate_certificate_id: row.certificate_certificate_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getTableList();
              } else {
                self.$message.error(data.msg || '删除失败');
              }
            })
            .catch(error => {
              self.$message.error('删除失败，请稍后重试');
              console.error('删除失败:', error);
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    }
  },
  
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.saveTimer) {
      clearTimeout(this.saveTimer);
    }
  }
};
</script>

<style scoped>
.commission-cell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.commission-cell :deep(.el-input) {
  width: 120px;
}

.success-icon {
  color: #67C23A;
  font-size: 16px;
}

:deep(.el-table .el-table__cell) {
  padding: 8px 0;
}

:deep(.el-table .el-input__inner) {
  text-align: center;
}

/* 保存中的行样式 */
:deep(.saving-row) {
  opacity: 0.7;
}

/* 加载动画 */
.el-icon-loading {
  animation: rotating 2s linear infinite;
  color: #409EFF;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .commission-cell {
    flex-direction: column;
    gap: 4px;
  }
  
  .commission-cell :deep(.el-input) {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/certificate_certificate/index/index.vue